import isTrafficOrPower from "../isTrafficOrPowerItem";
import uniqueItems from "../removeDuplicateItens";

const extractItemIsNotTrafficNotPower = (itens, connection) => {
  return uniqueItems(itens)
    ?.filter((item) =>
      connection?.item?.some((con) => {
        const conKey = con?.key_?.toLowerCase();
        return con.itemId === item?.itemid && !isTrafficOrPower(conKey);
      })
    )
    ?.sort((a, b) => a.name?.localeCompare(b?.name));
};
const filterItemIsNotTrafficNotPower = (itens) => {
  return uniqueItems(itens)
    ?.filter((item) => !isTrafficOrPower(item?.key_))
    ?.sort((a, b) => a?.name?.localeCompare(b?.name));
};
export { extractItemIsNotTrafficNotPower, filterItemIsNotTrafficNotPower };
